export default class discussion {
    key?: string | null;
    user_designation: string;
    discussion_text: string;
    user_name: string;
    company_name:string;
  }
